export function removePreselectionFromSearchParams(
  search: string,
  lineCodeCampaignSearch: string | undefined,
): string {
  const searchParams = new URLSearchParams(search);
  const lineCodeCampaignSearchParams = new URLSearchParams(
    lineCodeCampaignSearch,
  );

  for (const [key, value] of lineCodeCampaignSearchParams.entries()) {
    searchParams.append(key, value);
  }

  searchParams.delete(`pn18`);
  searchParams.delete(`addToCart`);
  searchParams.delete(`lineCode`);
  searchParams.delete(`linecode`);

  const newSearch = searchParams.toString();

  return newSearch ? `?${newSearch}` : ``;
}
